import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import DropDown from 'react-select';
import FilterPortal from './FilterPortal';
import { isEmptyArray } from '../../../utils/arrays';
import Types from '../../../utils/filterTypes';
import { TextOptions, NumberOptions } from '../../../utils/filterOptions';

const initialState = {
  options: [],
  selected: [],
  advancedFilter: false,
  advancedFilters: [],
  hasFilter: false
};

export default class SuperFilter extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    column: PropTypes.any.isRequired,
    getValidFilterValues: PropTypes.func.isRequired,
  }

  state = initialState;

  onOpen = () => {
    this.setState({ options: this.getOptions() });
  }

  onConfirm = () => {
    const { selected } = this.state;
    this.setState({ hasFilter: this.hasFilter() }, () => {
      this.props.onChange({
        filterTerm: selected,
        column: this.props.column,
        rawValue: selected,
        filterValues: this.filterValues
      });
    });
  };

  onClear = () => {
    this.props.onChange({
      filterTerm: [],
      column: this.props.column,
      rawValue: [],
      filterValues: this.filterValues
    });
    this.clean();
  }

  getOptions = () => {
    const { getValidFilterValues, column: { key, type, toOption = data => data } } = this.props;
    let options = getValidFilterValues(key);
    options = options.map((o) => {
      if (typeof o === 'string') {
        return { value: o, label: o };
      }
      if (typeof o === 'number') {
        return { value: o, label: `${o}` };
      }
      if (typeof o === 'object') {
        return toOption(o);
      }
      return { value: null, label: '' };
    });
    options.push({ value: '__selectall__', label: 'SELECIONAR TODOS' });
    const groupedByNameValue = _.groupBy(options, 'label', 'value');
    const keys = Object.keys(groupedByNameValue);
    options = keys.map(key => groupedByNameValue[key][0]);
    if (type === Types.NUMBER) {
      return options.sort(this.compareNumber);
    } else if (type === Types.OBJECT) {
      return options.sort(this.compareObject)
    }
    return options.sort(this.compareText);
  }

  clean = () => {
    this.setState(initialState);
  }

  compareText = (a, b) => {
    const { column: { getValueToSort = ({ value }) => value } } = this.props;
    if (a.value === '__selectall__') return -1;
    if (b.value === '__selectall__') return 1;
    const valueA = getValueToSort(a);
    const valueB = getValueToSort(b);
    if (valueA === valueB) return 0;
    return (valueA < valueB) ? -1 : 1;
  }

  compareNumber = (a, b) => {
    const { column: { getValueToSort = ({ value }) => value } } = this.props;
    if (a.value === '__selectall__') return -1;
    if (b.value === '__selectall__') return 1;
    const valueA = getValueToSort(a);
    const valueB = getValueToSort(b);
    return valueA - valueB;
  }

  compareObject = (a, b) => {
    const { column: { getValueToSort = ({ value }) => value } } = this.props;
    if (a.value === '__selectall__') return -1;
    if (b.value === '__selectall__') return 1;
    const valueA = getValueToSort(a);
    const valueB = getValueToSort(b);
    return valueA < valueB ? -1 : 1;
  }

  validateFiltersText = (value) => {
    let actualCondition = true;
    this.state.advancedFilters.forEach((a) => {
      const loopValue = a.advancedFilterValue;
      let loopCondition = true;

      if (loopValue) {
        switch (a.advancedFilterType) {
          case 'CONTAINS': {
            loopCondition = value.includes(loopValue.toUpperCase());
            break;
          }
          case 'EQUAL': {
            const stringA = String(value).trim();
            const stringB = String(loopValue.toUpperCase()).trim();
            loopCondition = (stringA === stringB);
            break;
          }
          case 'NOT_CONTAINS': {
            loopCondition = !value.includes(loopValue.toUpperCase());
            break;
          }
          case 'NOT_EQUAL': {
            const stringA = String(value).trim();
            const stringB = String(loopValue.toUpperCase()).trim();
            loopCondition = (stringA !== stringB);
            break;
          }
          default:
            break;
        }
      }

      if (a.advancedFilterOption === 'AND') {
        actualCondition = actualCondition && loopCondition;
      }
      if (a.advancedFilterOption === 'OR') {
        actualCondition = actualCondition || loopCondition;
      }
    });

    return actualCondition;
  }

  validateFiltersNumber = (value) => {
    let actualCondition = true;
    this.state.advancedFilters.forEach((a) => {
      const loopValue = a.advancedFilterValue;
      let loopCondition = true;

      if (loopValue) {
        switch (a.advancedFilterType) {
          case 'EQUAL': {
            loopCondition = value === loopValue;
            break;
          }
          case 'NOT_EQUAL': {
            loopCondition = value !== loopValue;
            break;
          }
          case 'GREATER_THAN': {
            loopCondition = value > loopValue;
            break;
          }
          case 'EQUAL_GREATER_THAN': {
            loopCondition = value >= loopValue;
            break;
          }
          case 'LESS_THAN': {
            loopCondition = value < loopValue;
            break;
          }
          case 'EQUAL_LESS_THAN': {
            loopCondition = value <= loopValue;
            break;
          }
          default:
            break;
        }
      }

      if (a.advancedFilterOption === 'AND') {
        actualCondition = actualCondition && loopCondition;
      }
      if (a.advancedFilterOption === 'OR') {
        actualCondition = actualCondition || loopCondition;
      }
    });

    return actualCondition;
  }

  filterValues = (row, columnFilter, columnKey) => {
    const value = row[columnKey];
    const { column } = this.props;
    if (this.state.advancedFilter) {
      if (column.type === Types.TEXT) {
        return this.validateFiltersText(value.toUpperCase());
      }
      if (column.type === Types.NUMBER) {
        return this.validateFiltersNumber(value);
      }
    } else {
      if (columnFilter === null) {
        return false;
      }
      if (!isEmptyArray(columnFilter.filterTerm)) {
        const filterHandler = column.type === Types.OBJECT
          ? (filterTerm) => filterTerm === column.toOption(value).value
          : (filterTerm) => filterTerm === value;
        return columnFilter.filterTerm.some(filterHandler);
      }
    }

    return true;
  }

  addOption = (e, item) => {
    this.setState((state) => {
      const newSelected = [...state.selected, item.value];
      return { selected: newSelected };
    });
  };

  removeOption = (e, item) => {
    this.setState((state) => {
      const newSelected = state.selected.filter(x => x !== item.value);
      return { selected: newSelected };
    });
  };

  selectAll = (isUsing, filterText) => {
    const { options } = this.state;
    const hasFilterText = new RegExp(filterText, 'ig');
    if (isUsing) {
      this.setState({ selected: [] });
    } else {
      const selected = options.map(o => o.value);
      const actualOptions = filterText
        ? selected.filter((o) => {
          if (o === '__selectall__') return true;
          return o.match(hasFilterText);
        }) : selected;
      this.setState({
        selected: actualOptions
      });
    }
  }

  isUsingOption = (item) => {
    return this.state.selected.some(s => s === item.value);
  };

  toggleOption = (e, isUsing, item) => {
    if (isUsing) {
      this.removeOption(e, item);
    } else {
      this.addOption(e, item);
    }
  };

  hasFilter = () => {
    const { advancedFilter, advancedFilters, selected } = this.state;
    return (!advancedFilter && selected.length > 0)
      || (!advancedFilter && selected.size > 0)
      || (advancedFilter && advancedFilters.some(x => x.advancedFilterValue));
  }

  renderHeaderTitle = () => {
    const isAdvanced = this.state.advancedFilter;
    return (
      <div>
        <span
          className={!isAdvanced ? 'is-active' : ''}
          onClick={() => this.setState({ advancedFilter: false })}
        >
          Filtros
        </span>
        <span> | </span>
        <span
          className={isAdvanced ? 'is-active' : ''}
          onClick={() => this.setState({ advancedFilter: true })}
        >
          Avançado
        </span>
      </div>
    );
  };

  renderAdvancedFilters = () => {
    const { advancedFilters } = this.state;

    if (advancedFilters.length === 0) return <p>Nenhum filtro adicionado.</p>;

    return advancedFilters.map((filter, idx) => {
      const key = idx;
      return (
        <div className="advanced-filter-form" key={`filters-${key}`}>
          {idx > 0 && this.renderFilterOptions(idx)}
          {this.renderFilterTypes(idx)}
          <input
            key={`filters-${key}`}
            value={this.state.advancedFilters[idx].advancedFilterValue}
            type="text"
            className="form-control"
            id="advancedFilterValue"
            name={this.props.column.key}
            placeholder="Valor"
            onChange={(e) => {
              this.handleChange(e.target.value, idx, 'advancedFilterValue');
            }}
            onFocus={e => e.nativeEvent.stopImmediatePropagation()}
          />
        </div>
      );
    });
  }

  getFilterOptions = () => {
    const options = [];
    if (this.props.column.type === Types.NUMBER) {
      NumberOptions.forEach((v, k) => {
        options.push({ label: v, value: k });
      });
    } else if (this.props.column.type === Types.TEXT) {
      TextOptions.forEach((v, k) => {
        options.push({ label: v, value: k });
      });
    }
    return options;
  }

  renderFilterOptions = (idx) => {
    const filterOptions = [
      { value: 'AND', label: 'e' },
      { value: 'OR', label: 'ou' }
    ];

    const { advancedFilters } = this.state;
    const { advancedFilterOption } = advancedFilters[idx];
    const currentValue = filterOptions
      .find(x => x.value === advancedFilterOption);

    return (
      <DropDown
        placeholder=""
        isSearchable={false}
        value={currentValue}
        onChange={o => this.handleChange(o, idx, 'advancedFilterOption')}
        id="advancedFilterOption"
        options={filterOptions}
        getOptionLabel={o => o.label}
        getOptionValue={o => o.value}
      />
    );
  }

  renderFilterTypes = (idx) => {
    const options = this.getFilterOptions();

    const { advancedFilters } = this.state;
    const { advancedFilterType } = advancedFilters[idx];
    const currentValue = options
      .find(x => x.value === advancedFilterType);

    return (
      <DropDown
        placeholder="Condição..."
        isSearchable={false}
        value={currentValue}
        onChange={o => this.handleChange(o, idx, 'advancedFilterType')}
        options={options}
        getOptionLabel={o => o.label}
        getOptionValue={o => o.value}
        id="advancedFilterType"
      />
    );
  }

  handleChange = (option, idx, filterKey) => {
    this.setState((state) => {
      const filters = state.advancedFilters;
      filters[idx][filterKey] = (option && option.value) || option;
      return { advancedFilters: filters };
    });
  };

  renderAdvancedFilter = () => {
    const addFilter = () => {
      this.setState((state) => {
        const virtual = state.advancedFilters;
        virtual.push({
          advancedFilterOption: 'AND',
          advancedFilterType: 'EQUAL',
          advancedFilterValue: ''
        });
        return { advancedFilters: virtual };
      });
    };

    const removeFilter = () => {
      this.setState((state) => {
        const virtual = state.advancedFilters;
        virtual.pop();
        return { advancedFilters: virtual };
      });
    };

    return (
      <div className="advanced-filter">
        {this.renderAdvancedFilters()}
        <div className="advanced-filter-buttons">
          <button
            type="button"
            className="btn btn-add-advanced-filter btn-sm"
            onClick={addFilter}
          >
            Adiciona
          </button>
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={removeFilter}
          >
            Apaga
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { options } = this.state;
    return (
      <FilterPortal
        onShowDropdown={this.onOpen}
        onConfirm={this.onConfirm}
        onClear={this.onClear}
        data={options}
        isUsingOption={this.isUsingOption}
        toggleOption={this.toggleOption}
        onSelectAll={this.selectAll}
        filterKeys={['value', 'label']}
        renderHeaderTitle={this.renderHeaderTitle}
        renderAdvancedFilter={this.renderAdvancedFilter}
        hasFilter={this.state.hasFilter}
        isAdvanced={this.state.advancedFilter}
      />
    );
  }
}
